import { ITelemetryLogger } from '@cian/telemetry/shared';

export enum ETelemetryEvents {
  ChatFileDownloadSuccess = 'chats.chat-file-download.success',
  ChatFileDownloadFail = 'chats.chat-file-download.fail',
  ChatWsMessageSendSuccess = 'chats.chat-ws-message-send.success',
  ChatWsMessageSendFail = 'chats.chat-ws-message-send.fail',
  ChatWsMessageGetModalWarning = 'chats.chat-ws-message-get-modal-warning',
  ChatWsTokenSuccess = 'chats.chat-ws-token.success',
  ChatWsTokenError = 'chats.chat-ws-token.error',
  ChatWsSocketError = 'chats.chat-ws-socket.error',
  ChatWsSocketClose = 'chats.chat-ws-socket.close',
  ChatWsSessionSuccess = 'chats.chat-ws-session.success',
  ChatWsSessionFail = 'chats.chat-ws-session.fail',
  ChatWsSessionExpire = 'chats.chat-ws-session.expire',
  ChatWsUserStatusSuccess = 'chats.chat-ws-user-status.success',
  ChatWsUserStatusFail = 'chats.chat-ws-user-status.fail',
  ChatPageCrashFail = 'chats.chat-page-crash.fail',
  ChatPageShowErrorPage = 'chats.chat-page-show-error-page',
  ChatPageShow404ErrorPage = 'chats.chat-page-show-not-found-error-page',
  FeedbackChatbotModalShow = 'chats.chat-bot.feedback-show',
  FeedbackChatbotModalShowButton = 'chats.chat-bot.feedback-show.button',
  FeedbackChatbotModalHide = 'chats.chat-bot.feedback-hide',
  FeedbackChatbotModalRating = 'chats.chat-bot.feedback-rating',
  ChatWsTokenConnectTime = 'chats.chat-ws-token.time',
  ChatWsFirstMessageGetSuccess = 'chats.chat-ws-first-message-get.success',
  ChatFirstMessageSendSuccess = 'chats.first-message-send.success',
  ChatFirstMessageSendFail = 'chats.first-message-send.fail',
  ChatFirstMessageGetCaptcha = 'chats.first-message-get-captcha',
  ChatWsAnswerSendSuccess = 'chats.chat-ws-answer-send.success',
  ChatWsAnswerSendFail = 'chats.chat-ws-answer-send.fail',
  ChatNotificationShow = 'chats.chat-notification-show',
}

export type TAppTelemetryLogger = Omit<ITelemetryLogger, 'timer'>;
